import React, { useState } from 'react';
import styled from 'styled-components';
import { persistenceSearch, persistenceClear } from '@api/persistence';
import { useSelector } from 'react-redux';
import { getUserProfile } from '@store/common/selectors';
import { Button } from 'antd';
import { ProductSelector, KeySelector, UsernameInput } from './ReportSelector';
import ResultTable from './ResultTable';

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 2%;
  display: flex;
  flex-direction: column;
`;

const Section = styled.div`
  margin-top: 2%;
  div, span {
    margin-right: 5px;
  }
`;

function Manage() {
  const profile = useSelector(getUserProfile);

  const [data, setData] = useState([]);
  const [username, setUsername] = useState('');
  const [productId, setProductId] = useState(1);
  const [persistenceKey, setPersistenceKey] = useState('/');
  const [loading, setLoading] = useState(false);

  const handleKeyChange = (value) => {
    setPersistenceKey(value);
  };

  const handleProductChange = (value) => {
    setProductId(value);
  };

  const handleUsernameChange = (e) => {
    setUsername(e.target.value);
  };

  const handleSearch = async () => {
    if (username === '') {
      alert('Username is required');
      return;
    }
    setLoading(true);
    const result = await persistenceSearch({ key: persistenceKey, productId, username });
    if (result.data && result.data.data) {
      setData(result.data.data);
      setLoading(false);
    }
  };

  const onClear = async (id) => {
    await persistenceClear({ id });
    handleSearch();
  };

   // accessible only for internal users
   if (!profile.hidden) {
    return (
      <div>Forbidden: You dont have the permissions to access this page.</div>
    );
  }

  return (
    <Wrapper>
      <h3>Manage Persistence </h3>
      <Section>
        <UsernameInput handleChange={handleUsernameChange} selected={username} handleSearch={handleSearch} />
        <ProductSelector handleChange={handleProductChange} selected={productId} />
        <KeySelector handleChange={handleKeyChange} selected={persistenceKey} />
        <Button type="primary" onClick={handleSearch}>Search</Button>
      </Section>
      <Section>
        { loading
          ? <Wrapper>Loading...</Wrapper>
          : <ResultTable data={data} onClear={onClear} />
        }
      </Section>

    </Wrapper>
  );
}

export default Manage;
